/**
 * Lazy taxonomy loader.
 *
 * The taxonomy is ~5MB of JSON. Loading it on first paint would make the app
 * feel broken for every visitor, including the ones who never upload anything.
 * So it is code-split and fetched only when intake actually starts, and the
 * resolver is built once and reused.
 */
let resolverPromise = null;

export function loadResolver() {
  if (!resolverPromise) {
    resolverPromise = (async () => {
      const [{ createResolver }, titles, occupations] = await Promise.all([
        import("../utils/titleResolver.js"),
        import("../data/taxonomy/titles.json"),
        import("../data/taxonomy/occupations.json"),
      ]);
      return createResolver(titles.default, occupations.default);
    })();
  }
  return resolverPromise;
}

/** Skill element dictionary, loaded separately — much smaller. */
let skillsPromise = null;
export function loadSkills() {
  if (!skillsPromise) {
    skillsPromise = import("../data/taxonomy/skills.json").then((m) => m.default);
  }
  return skillsPromise;
}

/**
 * Occupations by code. Shares the same module the resolver already pulls, so
 * this adds a lookup table, not a second download.
 */
let occPromise = null;
export function loadOccupations() {
  if (!occPromise) {
    occPromise = import("../data/taxonomy/occupations.json").then((m) => {
      const byCode = new Map();
      for (const o of m.default) byCode.set(o.code, o);
      return byCode;
    });
  }
  return occPromise;
}
